import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  ENumber,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutNavbarLogoCenter = {
  factory: EElement({
    id: '613e419a-c052-6d8e-4686-db38ee556ed7',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('div'),
      styleBlockIds: EList([EText('467adbf5-75fb-afd1-150d-d69b1479893e')]),
      children: EList([
        EElement({
          id: 'c393cb5a-7fa8-610d-2c93-efcb454625d1',
          type: qualify(
            Plugins.name('Navbar'),
            Component.name('NavbarWrapper')
          ),
          data: ERecord({
            tag: EEnum('div'),
            navbar: ERecord({
              animation: EEnum('default'),
              collapse: EText('medium'),
              docHeight: EBoolean(false),
              duration: ENumber(400),
              easing: EEnum('ease'),
              easing2: EEnum('ease'),
              noScroll: EBoolean(false),
              type: EText('wrapper'),
            }),
            styleBlockIds: EList([
              EText('9628f9bb-c2d6-cdef-3dc9-f9d84be83744'),
              EText('c02cb2c3-bf8f-8db1-b35e-ecc7259250df'),
            ]),
            temp: ERecord({
              navbar: ERecord({
                menu: EEnum('hide'),
              }),
            }),
            children: EList([
              EElement({
                id: 'c393cb5a-7fa8-610d-2c93-efcb454625d2',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('81b59867-fdee-430e-3436-1014d50622b3'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'c393cb5a-7fa8-610d-2c93-efcb454625d3',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('f72870eb-0710-a79e-b13e-082441b80827'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'c393cb5a-7fa8-610d-2c93-efcb454625d4',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarBrand')
                            ),
                            data: ERecord({
                              navbar: ERecord({
                                type: EText('brand'),
                              }),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse('{"mode":"external"}'),
                              }),
                              eventIds: EList([]),
                              styleBlockIds: EList([
                                EText('b4e6e372-731e-6aa2-664d-43f317e9176c'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'c393cb5a-7fa8-610d-2c93-efcb454625d5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.companyLogoPlaceholder),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"6272efd796e7aa74d4f67d96"}'
                                      ),
                                    }),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'c393cb5a-7fa8-610d-2c93-efcb454625d6',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarMenu')
                            ),
                            data: ERecord({
                              tag: EEnum('nav'),
                              navbar: ERecord({
                                type: EText('menu'),
                              }),
                              attr: ERecord({
                                role: EText('navigation'),
                              }),
                              styleBlockIds: EList([
                                EText('ff7525d0-31bf-cee4-b713-8dce0082f7da'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'c393cb5a-7fa8-610d-2c93-efcb454625d7',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        'dc38b4c7-2894-93d6-c29b-a75909ebabad'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '6a52fa0b-576b-5b00-761f-8ed31e5afa33',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('List')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('ul'),
                                          list: ERecord({
                                            type: EText('list'),
                                            unstyled: EBoolean(true),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '0dbb42f2-4eec-f53b-5de3-73c6f6b0bc6b'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '6a52fa0b-576b-5b00-761f-8ed31e5afa34',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('ListItem')
                                              ),
                                              data: ERecord({
                                                list: ERecord({
                                                  type: EText('item'),
                                                }),
                                                text: EBoolean(false),
                                                children: EList([
                                                  EElement({
                                                    id: '8ffdae77-de86-a24b-48dc-ded7a08edf16',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Link')
                                                    ),
                                                    data: ERecord({
                                                      button: EBoolean(false),
                                                      eventIds: EList([]),
                                                      link: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Basic'),
                                                          typeName('Link')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"mode":"external","url":"#"}'
                                                        ),
                                                      }),
                                                      block: EText(''),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '8ffdae77-de86-a24b-48dc-ded7a08edf17',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'Feature'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '6a52fa0b-576b-5b00-761f-8ed31e5afa35',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('ListItem')
                                              ),
                                              data: ERecord({
                                                list: ERecord({
                                                  type: EText('item'),
                                                }),
                                                text: EBoolean(false),
                                                children: EList([
                                                  EElement({
                                                    id: '5e69d9bd-9376-8978-a2d6-8957dd6e89be',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Link')
                                                    ),
                                                    data: ERecord({
                                                      button: EBoolean(false),
                                                      eventIds: EList([]),
                                                      link: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Basic'),
                                                          typeName('Link')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"mode":"external","url":"#"}'
                                                        ),
                                                      }),
                                                      block: EText(''),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          'afc274d7-2178-837c-3ef8-2c663643cdf3'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '5e69d9bd-9376-8978-a2d6-8957dd6e89bf',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'Pricing'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: '6a52fa0b-576b-5b00-761f-8ed31e5afa36',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('ListItem')
                                              ),
                                              data: ERecord({
                                                list: ERecord({
                                                  type: EText('item'),
                                                }),
                                                text: EBoolean(false),
                                                children: EList([
                                                  EElement({
                                                    id: '1fe53054-4af6-c164-499f-d07a86e8e3fa',
                                                    type: qualify(
                                                      Plugins.name('Dropdown'),
                                                      Component.name(
                                                        'DropdownWrapper'
                                                      )
                                                    ),
                                                    data: ERecord({
                                                      tag: EEnum('div'),
                                                      dropdown: ERecord({
                                                        type: EText('wrapper'),
                                                      }),
                                                      attr: ERecord({
                                                        'data-hover':
                                                          EBoolean(false),
                                                        'data-delay':
                                                          ENumber(0),
                                                      }),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '0728d15e-0237-1200-955a-3690717e22b3'
                                                        ),
                                                      ]),
                                                      temp: ERecord({
                                                        dropdown: ERecord({
                                                          menu: EEnum('hide'),
                                                        }),
                                                      }),
                                                      children: EList([
                                                        EElement({
                                                          id: '1fe53054-4af6-c164-499f-d07a86e8e3fb',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Dropdown'
                                                            ),
                                                            Component.name(
                                                              'DropdownToggle'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            tag: EEnum('div'),
                                                            dropdown: ERecord({
                                                              type: EText(
                                                                'toggle'
                                                              ),
                                                            }),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '3899de5c-e452-4345-eecb-810516b0f7f6'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: '1fe53054-4af6-c164-499f-d07a86e8e3fc',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Icon'
                                                                  ),
                                                                  Component.name(
                                                                    'Icon'
                                                                  )
                                                                ),
                                                                data: ERecord({
                                                                  widget:
                                                                    ERecord({
                                                                      type: EText(
                                                                        'icon'
                                                                      ),
                                                                      icon: EText(
                                                                        'dropdown-toggle'
                                                                      ),
                                                                    }),
                                                                  styleBlockIds:
                                                                    EList([
                                                                      EText(
                                                                        'ce5a6fe5-43dd-d941-77d8-d02214336a9e'
                                                                      ),
                                                                    ]),
                                                                  children:
                                                                    EList([]),
                                                                }),
                                                              }),
                                                              EElement({
                                                                id: '1fe53054-4af6-c164-499f-d07a86e8e3fd',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Basic'
                                                                  ),
                                                                  Component.name(
                                                                    'Block'
                                                                  )
                                                                ),
                                                                data: ERecord({
                                                                  tag: EEnum(
                                                                    'div'
                                                                  ),
                                                                  text: EBoolean(
                                                                    true
                                                                  ),
                                                                  children:
                                                                    EList([
                                                                      EElement({
                                                                        id: '1fe53054-4af6-c164-499f-d07a86e8e3fe',
                                                                        type: qualify(
                                                                          Plugins.name(
                                                                            'Basic'
                                                                          ),
                                                                          Component.name(
                                                                            'String'
                                                                          )
                                                                        ),
                                                                        data: EText(
                                                                          'Resources'
                                                                        ),
                                                                      }),
                                                                    ]),
                                                                }),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                        EElement({
                                                          id: '1fe53054-4af6-c164-499f-d07a86e8e3ff',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Dropdown'
                                                            ),
                                                            Component.name(
                                                              'DropdownList'
                                                            )
                                                          ),
                                                          data: ERecord({
                                                            tag: EEnum('nav'),
                                                            dropdown: ERecord({
                                                              type: EText(
                                                                'list'
                                                              ),
                                                            }),
                                                            styleBlockIds:
                                                              EList([
                                                                EText(
                                                                  '16e55e89-b250-51f9-3973-7fe101c92560'
                                                                ),
                                                                EText(
                                                                  'd7476783-9f65-933c-7c1b-3ee135b53baf'
                                                                ),
                                                                EText(
                                                                  '765ebb9a-7c67-8b78-3c36-04a67e120ad7'
                                                                ),
                                                              ]),
                                                            children: EList([
                                                              EElement({
                                                                id: '1fe53054-4af6-c164-499f-d07a86e8e400',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Dropdown'
                                                                  ),
                                                                  Component.name(
                                                                    'DropdownLink'
                                                                  )
                                                                ),
                                                                data: ERecord({
                                                                  dropdown:
                                                                    ERecord({
                                                                      type: EText(
                                                                        'link'
                                                                      ),
                                                                    }),
                                                                  attr: ERecord(
                                                                    {
                                                                      id: EText(
                                                                        ''
                                                                      ),
                                                                    }
                                                                  ),
                                                                  link: ELiteral(
                                                                    {
                                                                      name: qualify(
                                                                        Plugins.name(
                                                                          'Basic'
                                                                        ),
                                                                        typeName(
                                                                          'Link'
                                                                        )
                                                                      ),
                                                                      value:
                                                                        JSON.parse(
                                                                          '{"url":"#","mode":"external"}'
                                                                        ),
                                                                    }
                                                                  ),
                                                                  eventIds:
                                                                    EList([]),
                                                                  styleBlockIds:
                                                                    EList([
                                                                      EText(
                                                                        '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                      ),
                                                                    ]),
                                                                  children:
                                                                    EList([
                                                                      EElement({
                                                                        id: '1fe53054-4af6-c164-499f-d07a86e8e401',
                                                                        type: qualify(
                                                                          Plugins.name(
                                                                            'Basic'
                                                                          ),
                                                                          Component.name(
                                                                            'String'
                                                                          )
                                                                        ),
                                                                        data: EText(
                                                                          'Resource Link 1'
                                                                        ),
                                                                      }),
                                                                    ]),
                                                                }),
                                                              }),
                                                              EElement({
                                                                id: '1fe53054-4af6-c164-499f-d07a86e8e402',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Dropdown'
                                                                  ),
                                                                  Component.name(
                                                                    'DropdownLink'
                                                                  )
                                                                ),
                                                                data: ERecord({
                                                                  dropdown:
                                                                    ERecord({
                                                                      type: EText(
                                                                        'link'
                                                                      ),
                                                                    }),
                                                                  attr: ERecord(
                                                                    {
                                                                      id: EText(
                                                                        ''
                                                                      ),
                                                                    }
                                                                  ),
                                                                  link: ELiteral(
                                                                    {
                                                                      name: qualify(
                                                                        Plugins.name(
                                                                          'Basic'
                                                                        ),
                                                                        typeName(
                                                                          'Link'
                                                                        )
                                                                      ),
                                                                      value:
                                                                        JSON.parse(
                                                                          '{"url":"#","mode":"external"}'
                                                                        ),
                                                                    }
                                                                  ),
                                                                  eventIds:
                                                                    EList([]),
                                                                  styleBlockIds:
                                                                    EList([
                                                                      EText(
                                                                        '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                      ),
                                                                    ]),
                                                                  children:
                                                                    EList([
                                                                      EElement({
                                                                        id: '1fe53054-4af6-c164-499f-d07a86e8e403',
                                                                        type: qualify(
                                                                          Plugins.name(
                                                                            'Basic'
                                                                          ),
                                                                          Component.name(
                                                                            'String'
                                                                          )
                                                                        ),
                                                                        data: EText(
                                                                          'Resource Link 2'
                                                                        ),
                                                                      }),
                                                                    ]),
                                                                }),
                                                              }),
                                                              EElement({
                                                                id: '1fe53054-4af6-c164-499f-d07a86e8e404',
                                                                type: qualify(
                                                                  Plugins.name(
                                                                    'Dropdown'
                                                                  ),
                                                                  Component.name(
                                                                    'DropdownLink'
                                                                  )
                                                                ),
                                                                data: ERecord({
                                                                  dropdown:
                                                                    ERecord({
                                                                      type: EText(
                                                                        'link'
                                                                      ),
                                                                    }),
                                                                  attr: ERecord(
                                                                    {
                                                                      id: EText(
                                                                        ''
                                                                      ),
                                                                    }
                                                                  ),
                                                                  link: ELiteral(
                                                                    {
                                                                      name: qualify(
                                                                        Plugins.name(
                                                                          'Basic'
                                                                        ),
                                                                        typeName(
                                                                          'Link'
                                                                        )
                                                                      ),
                                                                      value:
                                                                        JSON.parse(
                                                                          '{"url":"#","mode":"external"}'
                                                                        ),
                                                                    }
                                                                  ),
                                                                  eventIds:
                                                                    EList([]),
                                                                  styleBlockIds:
                                                                    EList([
                                                                      EText(
                                                                        '7b01a192-9eeb-e158-44d6-4af2632c5926'
                                                                      ),
                                                                    ]),
                                                                  children:
                                                                    EList([
                                                                      EElement({
                                                                        id: '1fe53054-4af6-c164-499f-d07a86e8e405',
                                                                        type: qualify(
                                                                          Plugins.name(
                                                                            'Basic'
                                                                          ),
                                                                          Component.name(
                                                                            'String'
                                                                          )
                                                                        ),
                                                                        data: EText(
                                                                          'Resource Link 3'
                                                                        ),
                                                                      }),
                                                                    ]),
                                                                }),
                                                              }),
                                                            ]),
                                                          }),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'ad5f475b-6531-ab6b-c476-880f5e81bfe9',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('List')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('ul'),
                                          list: ERecord({
                                            type: EText('list'),
                                            unstyled: EBoolean(true),
                                          }),
                                          styleBlockIds: EList([
                                            EText(
                                              '0dbb42f2-4eec-f53b-5de3-73c6f6b0bc6b'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: 'ad5f475b-6531-ab6b-c476-880f5e81bfea',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('ListItem')
                                              ),
                                              data: ERecord({
                                                list: ERecord({
                                                  type: EText('item'),
                                                }),
                                                text: EBoolean(false),
                                                children: EList([
                                                  EElement({
                                                    id: '1463f08b-1235-84d8-65ff-9e2d9c9611a7',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Link')
                                                    ),
                                                    data: ERecord({
                                                      button: EBoolean(false),
                                                      eventIds: EList([]),
                                                      link: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Basic'),
                                                          typeName('Link')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"mode":"external","url":"#"}'
                                                        ),
                                                      }),
                                                      block: EText(''),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          'da21d2ba-fc40-8d63-33c1-570c530821a1'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: '1463f08b-1235-84d8-65ff-9e2d9c9611a8',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText('Docs'),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                            EElement({
                                              id: 'ad5f475b-6531-ab6b-c476-880f5e81bfed',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('ListItem')
                                              ),
                                              data: ERecord({
                                                list: ERecord({
                                                  type: EText('item'),
                                                }),
                                                text: EBoolean(false),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '7eaeb850-ba72-ca30-1d30-50f76271bf84'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: 'cf83a031-236a-649e-89a0-fa0ad388ffec',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('Link')
                                                    ),
                                                    data: ERecord({
                                                      button: EBoolean(true),
                                                      eventIds: EList([]),
                                                      link: ELiteral({
                                                        name: qualify(
                                                          Plugins.name('Basic'),
                                                          typeName('Link')
                                                        ),
                                                        value: JSON.parse(
                                                          '{"mode":"external","url":"#"}'
                                                        ),
                                                      }),
                                                      block: EText(''),
                                                      styleBlockIds: EList([
                                                        EText(
                                                          '5811e2db-f107-fb36-bedc-ae019c696e30'
                                                        ),
                                                      ]),
                                                      children: EList([
                                                        EElement({
                                                          id: 'cf83a031-236a-649e-89a0-fa0ad388ffed',
                                                          type: qualify(
                                                            Plugins.name(
                                                              'Basic'
                                                            ),
                                                            Component.name(
                                                              'String'
                                                            )
                                                          ),
                                                          data: EText(
                                                            'Get Started'
                                                          ),
                                                        }),
                                                      ]),
                                                    }),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: 'c393cb5a-7fa8-610d-2c93-efcb454625ef',
                            type: qualify(
                              Plugins.name('Navbar'),
                              Component.name('NavbarButton')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              navbar: ERecord({
                                type: EText('button'),
                              }),
                              styleBlockIds: EList([
                                EText('f2a4d0f4-6afc-44f5-843b-063d94fa1d5d'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'c393cb5a-7fa8-610d-2c93-efcb454625f0',
                                  type: qualify(
                                    Plugins.name('Icon'),
                                    Component.name('Icon')
                                  ),
                                  data: ERecord({
                                    widget: ERecord({
                                      type: EText('icon'),
                                      icon: EText('nav-menu'),
                                    }),
                                    children: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '467adbf5-75fb-afd1-150d-d69b1479893e',
      type: 'class',
      name: 'Navbar Logo Center',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: '9628f9bb-c2d6-cdef-3dc9-f9d84be83744',
      type: 'class',
      name: 'Navbar Logo Center Container',
      comb: '',
      styleLess:
        'z-index: 5; width: 1030px; max-width: 100%; margin-right: auto; margin-left: auto; padding-top: 20px; padding-right: 20px; padding-bottom: 20px; padding-left: 20px; background-color: transparent;',
      children: ['c02cb2c3-bf8f-8db1-b35e-ecc7259250df'],
      variants: {},
    },
    {
      _id: 'c02cb2c3-bf8f-8db1-b35e-ecc7259250df',
      type: 'class',
      name: 'Shadow Three',
      comb: '&',
      styleLess: 'width: 100%; max-width: 1140px;',
      children: [],
      variants: {},
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: 'f72870eb-0710-a79e-b13e-082441b80827',
      type: 'class',
      name: 'Navbar Wrapper Three',
      comb: '',
      styleLess:
        'position: relative; display: flex; justify-content: center; align-items: center;',
      children: [],
      variants: {medium: {styleLess: 'justify-content: space-between;'}},
    },
    {
      _id: 'b4e6e372-731e-6aa2-664d-43f317e9176c',
      type: 'class',
      name: 'Navbar Brand Three',
      comb: '',
      styleLess: 'position: absolute; z-index: 5;',
      children: [],
      variants: {
        small: {styleLess: 'padding-left: 0px;'},
        medium: {styleLess: 'position: relative;'},
      },
    },
    {
      _id: 'ff7525d0-31bf-cee4-b713-8dce0082f7da',
      type: 'class',
      name: 'Nav Menu Wrapper Three',
      comb: '',
      styleLess: 'width: 100%;',
      children: [],
      variants: {
        medium: {styleLess: 'top: 70px; background-color: transparent;'},
      },
    },
    {
      _id: 'dc38b4c7-2894-93d6-c29b-a75909ebabad',
      type: 'class',
      name: 'Nav Menu Three',
      comb: '',
      styleLess:
        'display: flex; margin-bottom: 0px; justify-content: space-between; align-items: center;',
      children: [],
      variants: {
        medium: {
          styleLess:
            'display: flex; margin-top: 10px; padding-top: 20px; padding-right: 20px; padding-bottom: 20px; padding-left: 20px; justify-content: space-between; flex-wrap: wrap; align-items: center; border-top-left-radius: 50px; border-top-right-radius: 50px; border-bottom-left-radius: 50px; border-bottom-right-radius: 50px; background-color: hsla(0, 0.00%, 100.00%, 1.00); box-shadow: 0 8px 50px 0 hsla(0, 0.00%, 0.00%, 0.05);',
        },
        tiny: {styleLess: 'flex-direction: column;'},
        small: {
          styleLess:
            'padding-bottom: 30px; flex-direction: column; border-top-left-radius: 20px; border-top-right-radius: 20px; border-bottom-left-radius: 20px; border-bottom-right-radius: 20px;',
        },
      },
    },
    {
      _id: '0dbb42f2-4eec-f53b-5de3-73c6f6b0bc6b',
      type: 'class',
      name: 'Nav Menu Block',
      comb: '',
      styleLess:
        'display: flex; margin-bottom: 0px; justify-content: center; align-items: center;',
      children: [],
      variants: {small: {styleLess: 'flex-direction: column;'}},
    },
    {
      _id: 'afc274d7-2178-837c-3ef8-2c663643cdf3',
      type: 'class',
      name: 'Nav Link',
      comb: '',
      styleLess:
        'margin-right: 5px; margin-left: 5px; padding-top: 5px; padding-right: 10px; padding-bottom: 5px; padding-left: 10px; color: #1a1b1f; font-size: 14px; line-height: 20px; letter-spacing: 0.25px; text-decoration: none;',
      children: [],
      variants: {
        small: {
          styleLess:
            'display: inline-block; padding-top: 10px; padding-bottom: 10px;',
        },
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 4px; border-top-right-radius: 4px; border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
        medium: {styleLess: 'padding-right: 5px; padding-left: 5px;'},
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
      },
    },
    {
      _id: '0728d15e-0237-1200-955a-3690717e22b3',
      type: 'class',
      name: 'Nav Dropdown',
      comb: '',
      styleLess: 'margin-right: 5px; margin-left: 5px;',
      children: [],
      variants: {
        small: {
          styleLess:
            'display: flex; flex-direction: column; align-items: center;',
        },
      },
    },
    {
      _id: '3899de5c-e452-4345-eecb-810516b0f7f6',
      type: 'class',
      name: 'Nav Dropdown Toggle',
      comb: '',
      styleLess:
        'padding-top: 5px; padding-right: 30px; padding-bottom: 5px; padding-left: 10px; font-size: 14px; line-height: 20px; letter-spacing: 0.25px;',
      children: [],
      variants: {
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
        small: {styleLess: 'padding-top: 10px; padding-bottom: 10px;'},
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
      },
    },
    {
      _id: 'ce5a6fe5-43dd-d941-77d8-d02214336a9e',
      type: 'class',
      name: 'Nav Dropdown Icon',
      comb: '',
      styleLess: 'margin-right: 10px;',
      children: [],
      variants: {},
    },
    {
      _id: '16e55e89-b250-51f9-3973-7fe101c92560',
      type: 'class',
      name: 'Nav Dropdown List',
      comb: '',
      styleLess:
        'border-top-left-radius: 12px; border-top-right-radius: 12px; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px; background-color: white;',
      children: ['d7476783-9f65-933c-7c1b-3ee135b53baf'],
      variants: {
        main_open: {styleLess: 'padding-top: 10px; padding-bottom: 10px;'},
      },
    },
    {
      _id: 'd7476783-9f65-933c-7c1b-3ee135b53baf',
      type: 'class',
      name: 'Shadow Three',
      comb: '&',
      styleLess: '',
      children: ['765ebb9a-7c67-8b78-3c36-04a67e120ad7'],
      variants: {
        medium_open: {styleLess: 'position: absolute;'},
        small_open: {styleLess: 'position: relative;'},
        small: {
          styleLess: 'box-shadow: 0 8px 50px 0 hsla(0, 0.00%, 0.00%, 0.05);',
        },
      },
    },
    {
      _id: '765ebb9a-7c67-8b78-3c36-04a67e120ad7',
      type: 'class',
      name: 'Mobile Shadow Hide',
      comb: '&',
      styleLess: '',
      children: [],
      variants: {
        small: {
          styleLess:
            'box-shadow: none /* 0 8px 50px 0 hsla(0, 0.00%, 0.00%, 0.05) */;',
        },
      },
    },
    {
      _id: '7b01a192-9eeb-e158-44d6-4af2632c5926',
      type: 'class',
      name: 'Nav Dropdown Link',
      comb: '',
      styleLess: 'padding-top: 5px; padding-bottom: 5px; font-size: 14px;',
      children: [],
      variants: {
        'main_focus-visible': {
          styleLess:
            'border-top-left-radius: 5px; border-top-right-radius: 5px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; outline-color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00); outline-offset: 0px; outline-style: solid; outline-width: 2px; color: hsla(214.6153846153846, 100.00%, 37.00%, 1.00);',
        },
      },
    },
    {
      _id: 'da21d2ba-fc40-8d63-33c1-570c530821a1',
      type: 'class',
      name: 'Nav Link Accent',
      comb: '',
      styleLess:
        'margin-right: 20px; margin-left: 5px; padding-top: 5px; padding-right: 10px; padding-bottom: 5px; padding-left: 10px; color: #1a1b1f; font-size: 14px; line-height: 20px; font-weight: 700; letter-spacing: 0.25px; text-decoration: none;',
      children: [],
      variants: {
        small: {
          styleLess:
            'display: inline-block; margin-right: 5px; padding-top: 10px; padding-bottom: 10px;',
        },
        main_hover: {styleLess: 'color: rgba(26, 27, 31, 0.75);'},
      },
    },
    {
      _id: '7eaeb850-ba72-ca30-1d30-50f76271bf84',
      type: 'class',
      name: 'Mobile Margin Top 10',
      comb: '',
      styleLess: '',
      children: [],
      variants: {small: {styleLess: 'margin-top: 10px;'}},
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
    {
      _id: 'f2a4d0f4-6afc-44f5-843b-063d94fa1d5d',
      type: 'class',
      name: 'Menu button',
      comb: '',
      styleLess: '',
      children: [],
      variants: {
        medium_open: {
          styleLess:
            'background-color: hsla(213.60000000000002, 16.34%, 70.00%, 1.00); color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        medium: {
          styleLess:
            'padding-top: 12px; padding-right: 12px; padding-bottom: 12px; padding-left: 12px;',
        },
      },
    },
  ],
} as const;
